import { analytics_methods } from "../../utils/analytics_methods";
import addKeysToItems from "./schema";
import getItemstData from "../../utils/items_checkout";

function triggerEvent() {

    const schema = addKeysToItems({
        time_selected: "string",
        date_selected: "string",
        ticket_category: "string",
        }, 
        {transaction_id: "string"}
    );
    
    const data = {
        event: "purchase",
        event_type: "page_view",
        ecommerce: {
            value: window?.analytics_buendia?.total_value_with_commission ?? null,
            currency: window?.analytics_buendia?.currency || null,
            transaction_id: window?.analytics_buendia?.transaction_id || null,
            items: getItemstData()
        }
    }
    
    
    analytics_methods.sendToDataLayer(data, schema);
}


export const purchase_event = {
    triggerEvent
}